<template>
  <div class="chat_box_container" style="height: 100vh">
    <div v-if="cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'topic_selection_assistance'" style="height: 100%; width: 100%">
      <TopicAssistant @close_tool="close_tool" :greetingMsg="tool_list[cur_tool_idx]['label']" :curInfoToolTipMsg="tool_list[cur_tool_idx]['intro']" :dataContent="topicDataContent" :conversationId="conversation_id" :toolIdx="cur_tool_idx" :toolList="tool_list" />
    </div>
    <div v-else-if="cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'full_txt_art_analysis'" style="height: 100%; width: 100%">
      <FullTxtArtAnalysis @close_tool="close_tool" :greetingMsg="tool_list[cur_tool_idx]['label']" :curInfoToolTipMsg="tool_list[cur_tool_idx]['intro']" :dataContent="artAnalysisDataContent" :conversationId="conversation_id" />
    </div>
    <!-- <div v-else-if="cur_tool_idx!=null && tool_list[cur_tool_idx]['function']=='pdf_translation'" style="height: 100%; width: 100%;">
    <PdfTranslate 
      @close_tool="close_tool"
      :greetingMsg="tool_list[cur_tool_idx]['label']"
      :curInfoToolTipMsg="tool_list[cur_tool_idx]['intro']"
      :dataContent="artAnalysisDataContent"
    />
  </div> -->
    <div
      v-else
      @click="handleChatBoxClick"
      class="chat-main-shell"
      :class="{ 'is-welcome': greeting_label_show_state && cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'academic_search', 'chat-main-shell--academic': cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'academic_search' }"
      :style="user_input_move_to_bottom_state ? 'justify-content: space-between;' : 'justify-content: center;'"
    >
      <div style="height: 1px; position: relative">
        <span v-if="cur_tool_idx != null && tool_list[cur_tool_idx]['function'] != 'academic_search'" class="tool_label" @click="change_tool(null)">
          <i class="el-icon-arrow-left"></i>
          {{ tool_list[cur_tool_idx]["name"] }}
        </span>
      </div>

      <div style="height: 7 0vh; padding: 0 20px; height: 100vh" :class="greeting_label_show_state ? 'clomn_center' : 'clomn_between'">
        <div class="chat_box" ref="scrollContainer">
          <div v-if="conversation_restoring" class="conversation-restoring">
            <i class="el-icon-loading"></i>
            <span>正在恢复会话</span>
          </div>
          <template v-for="(chat, idx) in chat_history">
            <div v-if="chat['role'] == 'user'" class="user_chat" :key="idx" v-safe-html="chat['content']"></div>
            <div v-else class="bot_chat" :key="idx" v-safe-html="chat['content']" @click="handleBotAnswerClick" @mousemove="handleReferHover"></div>
          </template>

          <!-- <div :style="{ opacity: send_msg_btn_loading_state ? 0 : 1 }" style="height: 70px;">
          <template v-for="q,idx in extend_q">
            <div :key="idx" style="cursor: pointer; color:#888; margin: 5px; font-size: 15px;" @click="stream_chat(q)">{{ q }}<i class="el-icon-right"></i></div>
          </template>
        </div> -->

          <!-- <div class="user_chat">{{ uesr_question }}</div> -->
          <!-- <div class="bot_chat" v-safe-html="bot_answer"></div> -->
        </div>

        <!-- <div v-show="greeting_label_show_state" style="margin: 30px auto; font-size: 32px; font-weight: bold;">
        {{ greeting_msg }}
        <InfoTooltip v-if="info_tool_tip_show_state" :text="cur_info_tool_tip_msg"/>
      </div> -->

        <div>
          <div v-if="isAcademicWelcome" class="academic-welcome-title">
            <h1><span>AI</span>学术搜索 <i class="el-icon-magic-stick"></i></h1>
            <p>基于期刊、文献，提供可信赖的学术资源与深度解答</p>
          </div>
          <GreetingLabel v-show="greeting_label_show_state && !isAcademicWelcome" ref="childRefGreetingLabel" />
          <div class="user_input" style="border-radius: 10px; width: 100%; min-height: 60px; max-height: 620px; background-color: var(--bg-front); display: flex; flex-direction: column; justify-content: space-between">
            <div :class="isAcademicWelcome ? 'academic-search-field' : ''" style="position: relative">
              <i v-if="isAcademicWelcome" class="academic-search-icon el-icon-search"></i>
              <el-input v-show="user_input_show_state" style="margin-top: 10px" @keydown.enter.native="handleKeyDown" type="textarea" :autosize="{ minRows: 2, maxRows: 8 }" :placeholder="cur_placeholder_txt" v-model="user_input"> </el-input>
            </div>

            <div style="display: flex; flex-direction: row; justify-content: space-between; margin: 10px">
              <div class="input-tools-left">
                <!-- 2026-08-26 暂时隐藏「专业领域 / 专业」按钮：
                     该按钮只有一个选项，点击只是把 deepthink_on_state 由 false 再设为 false，
                     对用户没有任何可见反馈，容易引起困惑。deepthink_on_state 在 data 中已初始化为
                     false，请求参数 is_deep_think=off 不受影响。后续接入实际功能（如深度思考开关）
                     时再放出。
                <div class="model-select_model" v-if="!word_segment_field_show_state">
                  <div :class="!deepthink_on_state ? 'model-select_model_flex model-active_model' : 'model-select_model_flex'" @click.stop="deepthink_on_state = false">
                    <span class="dp-build-icon" style="display: inline-flex; justify-content: center; align-items: center; font-size: 20px">
                      <svg fill="none" viewBox="0 0 20 20" width="1em" height="1em">
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                          d="M10 12.5 7.5 10m2.5 2.5q1.75-.66 3.33-1.67M10 12.5v4.17s2.52-.46 3.33-1.67c.9-1.35 0-4.17 0-4.17M7.5 10q.66-1.73 1.67-3.3a10.7 10.7 0 0 1 9.16-5.03c0 2.26-.65 6.25-5 9.16M7.5 10H3.33S3.8 7.48 5 6.67c1.35-.9 4.17 0 4.17 0m-5.42 7.08c-1.25 1.05-1.67 4.17-1.67 4.17s3.12-.42 4.17-1.67c.6-.7.58-1.78-.08-2.43a1.8 1.8 0 0 0-2.42-.07"
                        ></path>
                      </svg>
                    </span>
                    <span v-if="!deepthink_on_state">{{ isAcademicWelcome ? "专业领域" : "专业" }}</span>
                  </div>
                </div>
                -->
                <span v-show="word_segment_field_show_state" @click.stop>
                  <el-dropdown @command="word_segment_field_change" style="vertical-align: sub">
                    <span class="el-dropdown-link" @click.stop style="color: #409eff; padding: 5px 10px"> 检索字段：{{ cur_word_segment_field }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="field in word_segment_field_list" :key="field" :command="field" :icon="cur_word_segment_field == field ? 'el-icon-circle-check' : 'el-icon-remove-outline'" :style="cur_word_segment_field == field ? 'color: #409EFF' : 'color: #666'">{{
                        field
                      }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                <!-- <el-upload class="upload-demo" :action="globalUrl.file_upload" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :multiple="false" :on-exceed="handleExceed" :on-success="handleUploadSuccess" :file-list="fileList" :accept="accept_file_list.join(',')"> -->
                <!-- <el-button style="border: none; margin-right: 10px" class="icon_small" round size="small" plain icon="el-icon-paperclip"></el-button> -->

                <!-- <span slot="tip" class="el-upload__tip" style="font-size: 15px">{{ upload_tips }}</span> -->

                <!-- </el-upload> -->
              </div>
              <div class="input-tools-right">
                <el-popover v-if="cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'academic_search'" v-model="personalizationPopoverVisible" trigger="click" placement="top" width="320" popper-class="personalization-popper" @show="handlePersonalizationOpen">
                  <el-button slot="reference" :class="['customization-button', isAcademicWelcome ? 'academic-filter-button' : '', hasActivePersonalizationFilters ? 'is-active' : '']" title="限定学科或期刊" aria-label="限定学科或期刊">
                    <i class="el-icon-s-operation"></i>
                    <span v-if="isAcademicWelcome">筛选</span>
                    <em v-if="isAcademicWelcome && hasActivePersonalizationFilters"></em>
                    <span v-if="isAcademicWelcome && hasActivePersonalizationFilters">已筛选 {{ activePersonalizationCount }} 项</span>
                  </el-button>
                  <div class="personalization-panel">
                    <div class="personalization-header">
                      <strong>筛选条件</strong>
                      <button class="personalization-close" type="button" @click="personalizationPopoverVisible = false">
                        <i class="el-icon-close"></i>
                      </button>
                    </div>
                    <div class="personalization-status-row">
                      <button class="personalization-clear" type="button" @click="clearPersonalizationFilters">清空筛选</button>
                      <div class="personalization-header-actions">
                        <i class="el-icon-collection-tag"></i>
                        <span>{{ personalizationStatusLabel }}</span>
                      </div>
                    </div>
                    <div class="personalization-field">
                      <span class="personalization-label">ESI 学科 <i class="el-icon-info"></i></span>
                      <el-select v-model="personalizationDisciplines" multiple collapse-tags filterable placeholder="选择学科" class="personalization-select" @change="schedulePersonalizationSave">
                        <el-option v-for="item in personalizationDisciplineOptions" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                      <div class="personalization-count-row">
                        <span>已选择 {{ personalizationDisciplines.length }} 个学科</span>
                        <button type="button" @click.stop="showSelectedPersonalization('disciplines')">查看全部 <i class="el-icon-arrow-right"></i></button>
                      </div>
                    </div>
                    <div class="personalization-field">
                      <span class="personalization-label">期刊 <i class="el-icon-info"></i></span>
                      <el-select
                        v-model="personalizationJournals"
                        class="personalization-select"
                        multiple
                        filterable
                        remote
                        reserve-keyword
                        :remote-method="handlePersonalizationJournalSearch"
                        :loading="personalizationJournalLoading"
                        allow-create
                        default-first-option
                        collapse-tags
                        placeholder="选择或输入期刊"
                        @change="schedulePersonalizationSave"
                      >
                        <el-option v-for="item in personalizationJournalOptions" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                      <div class="personalization-count-row">
                        <span>已选择 {{ personalizationJournals.length }} 个期刊</span>
                        <button type="button" @click.stop="showSelectedPersonalization('journals')">查看全部 <i class="el-icon-arrow-right"></i></button>
                      </div>
                    </div>
                    <div class="personalization-footer">
                      <el-button round size="small" @click="personalizationPopoverVisible = false">取消</el-button>
                      <el-button round size="small" type="primary" @click="personalizationPopoverVisible = false">应用筛选</el-button>
                    </div>
                  </div>
                </el-popover>
                <el-dialog :visible.sync="selectedPersonalizationDialogVisible" :title="selectedPersonalizationDialogTitle" width="420px" append-to-body custom-class="selected-personalization-dialog">
                  <div v-if="selectedPersonalizationItems.length" class="selected-personalization-list">
                    <div v-for="item in selectedPersonalizationItems" :key="item.value" class="selected-personalization-item">
                      <span :title="item.label">{{ item.label }}</span>
                      <button type="button" title="移除" @click="removeSelectedPersonalization(item.value)">
                        <i class="el-icon-close"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else class="selected-personalization-empty">{{ selectedPersonalizationEmptyText }}</div>
                  <span slot="footer">
                    <el-button round size="small" type="primary" @click="selectedPersonalizationDialogVisible = false">完成</el-button>
                  </span>
                </el-dialog>
                <el-button v-if="isAcademicWelcome" :disabled="!send_msg_btn_highlight_state" class="academic-search-submit" @click="stream_chat(user_input)">
                  <i class="el-icon-position"></i>
                  搜索
                </el-button>
                <span v-else-if="!send_msg_btn_highlight_state" class="dp-build-icon textarea_send-disabled__GF_p1 pointer" style="display: inline-flex; justify-content: center; align-items: center; font-size: 36px"
                  ><svg fill="none" viewBox="0 0 36 36" width="1em" height="1em">
                    <circle cx="18" cy="18" r="18" fill="currentColor"></circle>
                    <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 24.67V11.33m0 0-5 5m5-5 5 5"></path>
                  </svg>
                </span>
                <span v-else class="dp-build-icon text-color-primary pointer" @click="stream_chat(user_input)" style="display: inline-flex; justify-content: center; align-items: center; font-size: 36px"
                  ><svg fill="none" viewBox="0 0 36 36" width="1em" height="1em">
                    <circle cx="18" cy="18" r="18" fill="currentColor"></circle>
                    <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 24.67V11.33m0 0-5 5m5-5 5 5"></path>
                  </svg>
                </span>
              </div>
            </div>

            <div class="academic-assist-panel" v-if="greeting_label_show_state && cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'academic_search'">
              <div class="assist-type-row">
                <span class="assist-label">选择提问类型：</span>
                <div class="assist-items">
                  <el-tag v-for="item in academicSupportPrimaryLabels" :key="item" effect="plain" class="assist-chip support-chip" @click="applyDirectQuestionTypePreset(item)">
                    {{ item }}
                  </el-tag>
                  <el-popover placement="bottom-end" width="560" trigger="hover" popper-class="direct-ask-guide-popper" :open-delay="120">
                    <span slot="reference" class="question-guide-trigger">我该怎么提问</span>
                    <div class="direct-ask-guide">
                      <div class="direct-ask-guide-header">
                        <strong>我该怎么提问？</strong>
                        <span>选择一个方向，或直接点选示例发起搜索。</span>
                      </div>
                      <div v-for="section in directAskGuideSections" :key="section.title" class="direct-ask-guide-section">
                        <div class="direct-ask-guide-title">{{ section.title }}</div>
                        <div class="direct-ask-guide-examples">
                          <el-tag v-for="example in section.examples" :key="example" effect="plain" class="assist-chip direct-ask-guide-tag" :title="example" @click="applyDirectAskExample(example)">
                            {{ example }}
                          </el-tag>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </div>
              <div class="assist-content-grid">
                <div class="assist-list-section">
                  <div class="assist-section-header">
                    <strong>示例问题</strong>
                  </div>
                  <button v-for="item in directAskExamples" :key="item" class="assist-list-item" :title="item" @click.stop="applyDirectAskExample(item)">
                    <i class="el-icon-chat-dot-square"></i>
                    <span>{{ item }}</span>
                    <i class="el-icon-arrow-right"></i>
                  </button>
                </div>
                <div class="assist-list-section recent-section">
                  <div class="assist-section-header">
                    <strong>最近查询</strong>
                  </div>
                  <template v-if="recentDisplayItems.length">
                    <button v-for="item in recentDisplayItems" :key="item.text" class="assist-list-item" :title="item.text" @click.stop="applyRecentQuery(item)">
                      <i class="el-icon-time"></i>
                      <span>{{ item.text }}</span>
                      <em>{{ item.time }}</em>
                    </button>
                  </template>
                  <div v-else class="assist-empty">暂无最近查询</div>
                </div>
              </div>
            </div>
          </div>
          <el-row class="tool_intro_box" v-show="cur_tool_idx == null">
            <template v-for="(tool, idx) in tool_list">
              <el-button v-if="tool.name != '资源助手'" :disabled="tool['disabled']" :key="idx" style="margin: 5px; margin-left: 0" :icon="tool['icon']" round @click="handleTool(idx)" :title="tool['disabled'] ? '功能开发中...' : tool['name']">{{ tool["name"] }}</el-button>
            </template>
          </el-row>
          <el-row class="tool_intro_box" v-if="greeting_label_show_state && cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'word_segment_search'">
            <el-button v-for="(random_q, idx) in word_segment_search___random_q" :title="random_q" class="tool_intro_btn" :key="idx" style="margin: 5px" :icon="tool_list[cur_tool_idx]['icon']" round @click="stream_chat(random_q)">{{ random_q }}</el-button>
          </el-row>
          <el-row class="tool_intro_box" v-if="cur_tool_idx != null && tool_list[cur_tool_idx]['function'] == 'full_txt_art_analysis'">
            <div v-show="upload_recent_list.length > 0" style="margin: 10px; font-size: 13px; border-bottom: 1px solid var(--bg-front); color: var(--txt-color3) !important">最近上传</div>
            <el-button v-for="(upload_recent, idx) in upload_recent_list" :title="random_q" class="tool_intro_btn" :key="idx" style="margin: 5px" icon="el-icon-document" round @click="full_txt_art_analysis(upload_recent['file_ruid'], upload_recent['file_name'], true)">{{
              upload_recent["file_name"]
            }}</el-button>
          </el-row>
        </div>

        <div v-show="cur_tool_idx == null && greeting_label_show_state" style="height: 15vh"></div>
      </div>

      <ReferHoverTip :visible="activeItemId === currentItem.id" :article="currentItem.article" :position="tooltipPosition" :coordinates="tooltipCoordinates" @full_txt_art_analysis="full_txt_art_analysis" />

      <div style="position: fixed; top: 0; left: 0; width: 100%; z-index: 999; overflow-y: auto; height: 100vh" :class="analysis_table_show_state ? 'slow_show' : 'slow_hide'">
        <FullTxtArtAnalysisTip @clossPaperAnalysis="clossPaperAnalysis" :full_txt_art_analysis_data="full_txt_art_analysis_data"></FullTxtArtAnalysisTip>
      </div>
    </div>

    <div v-show="cur_tool_idx == null && greeting_label_show_state">
      <DataRecommend />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { globalUrl } from "@/config";

import { marked } from "marked";
import DOMPurify from "dompurify";
import hljs from "highlight.js";
import ReferHoverTip from "./ReferHoverTip.vue";
// import InfoTooltip from './InfoTooltip.vue'
import FullTxtArtAnalysis from "./FullTxtArtAnalysis.vue";
import FullTxtArtAnalysisTip from "./FullTxtArtAnalysisResultTip.vue";
import PdfTranslate from "./PdfTranslate.vue";
import GreetingLabel from "./GreetingLabel.vue";
import TopicAssistant from "./TopicAssistant.vue";
import DataRecommend from "./DataRecommend.vue";
import { allValuesEmpty } from "@/utils/objectUtils";
import { checkTextLength } from "@/utils/CheckStrLengthOp";
import { getOrgUrlInstance } from "../utils/authUtils";
import { findLeftBarRef } from "../utils/leftBarRef";
import EventBus from "../eventBus/EventBus.js";

const PERSONALIZATION_KEY = "aiserach.personalization";

export default {
  name: "ChatBox",
  components: {
    ReferHoverTip,
    // InfoTooltip,
    FullTxtArtAnalysis,
    FullTxtArtAnalysisTip,
    TopicAssistant,
    GreetingLabel,
    PdfTranslate,
    DataRecommend,
  },
  props: {
    conversation_id: {
      // type: String,
      required: true,
      default: () => null,
    },
    tool_idx: {
      // type: Object,
      required: true,
    },
    toolList: {
      // type: Object,
      required: true,
    },
    // 由 URL 上的会话 id 恢复而来（刷新/直达链接）。这种会话一定已经有历史消息，
    // 挂载时就按聊天态渲染，不要先亮一遍欢迎页再切过去。
    is_restored: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // user_id: '',
      // conversation_id: '',

      user_input: "",
      uesr_question: "",
      bot_answer: "",
      // answer_md_cache: '',
      // think_md_cache: '',
      chat_history: [],
      end_tag: "</end>",

      extend_q: [],

      work_bench_data_list: [],

      send_msg_btn_highlight_state: false,
      send_msg_btn_loading_state: false,

      greeting_msg: "",
      greeting_label_show_state: true,
      user_input_move_to_bottom_state: false,
      deepthink_on_state: false,
      answer_scroll_move_up: false,
      cur_tool_idx: null,
      tool_list: this.toolList,
      academic_search___random_q: [],
      personalizationPopoverVisible: false,
      personalizationDisciplines: [],
      personalizationJournals: [],
      personalizationSaved: false,
      personalizationOptionsLoaded: false,
      personalizationOptionsLoading: false,
      personalizationJournalLoading: false,
      personalizationJournalSearchTimer: null,
      personalizationJournalSearchRequestId: 0,
      selectedPersonalizationDialogVisible: false,
      selectedPersonalizationDialogType: "disciplines",
      personalizationDisciplineOptions: [
        { label: "Computer Science", value: "Computer Science" },
        { label: "Engineering", value: "Engineering" },
        { label: "Clinical Medicine", value: "Clinical Medicine" },
        { label: "Materials Science", value: "Materials Science" },
        { label: "Biology & Biochemistry", value: "Biology & Biochemistry" },
      ],
      personalizationJournalOptions: [
        { label: "Nature", value: "Nature" },
        { label: "Science", value: "Science" },
        { label: "IEEE Access", value: "IEEE Access" },
        { label: "Information Sciences", value: "Information Sciences" },
      ],
      supportedDirectQuestionTypeLabels: ["趋势综述", "方法清单", "对比分析", "机制解释", "风险局限", "定义查询", "数值查询", "文献定位"],
      directAskExamples: ["近五年 Transformer 在医学影像分割任务中的主要改进方向有哪些？", "医学问答中知识图谱增强方法与 RAG 方法在证据可追溯性上有何差异？", "主动学习和贝叶斯优化在材料发现中的代表性应用场景有哪些？"],
      defaultRecentQueries: [
        { text: "近五年 Transformer 在医学影像分割任务中的主要改进方向有哪些？", time: "10:32" },
        { text: "医学问答中知识图谱增强方法与 RAG 方法在证据可追溯性上有何差异？", time: "昨天 16:47" },
        { text: "主动学习和贝叶斯优化在材料发现中的代表性应用场景有哪些？", time: "05-14 09:21" },
      ],
      directAskGuideSections: [
        {
          title: "趋势与综述",
          examples: ["近五年 Transformer 在医学影像分割任务中的主要改进方向有哪些？", "多模态大模型用于临床问答和诊断辅助的研究进展如何？"],
        },
        {
          title: "方法与比较",
          examples: ["主动学习和贝叶斯优化在材料发现中的代表性应用场景有哪些？", "医学问答中知识图谱增强方法与 RAG 方法在证据可追溯性上有何差异？"],
        },
        {
          title: "定义、机制与数值",
          examples: ["知识蒸馏如何提升医学影像小模型的泛化能力？", "PD-1/PD-L1 抑制剂耐药机制有哪些研究证据？", "Pembrolizumab 在临床研究中报告的半衰期范围是多少？"],
        },
        {
          title: "文献定位",
          examples: ["Attentional control via synaptic gain mechanisms in auditory streaming", "上下文即一切：基于混合注意力机制的代码设计模式检测方法", "https://doi.org/10.1109/ACCESS.2025.3525849"],
        },
      ],
      recentQueriesTick: 0,
      word_segment_search___random_q: [],
      cur_info_tool_tip_msg: "",
      info_tool_tip_show_state: false,

      fileList: [],
      // accept_file_list: ['.*'],
      // accept_file_list: ['.pdf', '.jpg', '.jpeg', '.png'],
      accept_file_list: [".pdf"],
      max_file_num: 1,
      upload_recent_list: [],

      user_input_show_state: true,
      input_submit_show_state: true,
      deepthink_btn_show_state: true,
      upload_btn_show_state: false,
      upload_tips: "",

      analysis_table_show_state: false,
      full_txt_art_analysis_data: null,

      cur_hover_refer_idx: null,
      activeItemId: null,
      currentItem: { id: null, article: null },
      tooltipPosition: "top",
      tooltipCoordinates: { x: 0, y: 0 },
      // -----------------------------------------------------------------

      word_segment_field_list: ["智能判断", "题名", "作者", "doi", "关键词", "语种", "期刊"],
      cur_word_segment_field: "智能判断",
      word_segment_field_show_state: false,

      placeholder_default_txt: "询问任何科学问题",
      cur_placeholder_txt: "",

      topicDataContent: null,
      artAnalysisDataContent: null,
      lastLoadedConversationId: null,
      loadingConversationId: null,
      // 恢复既有会话且历史消息还没到，此时既不能显示欢迎页也没有消息可渲染
      conversation_restoring: false,
      authUtils: getOrgUrlInstance(this.$http),
    };
  },
  mounted() {
    let rendererMD = new marked.Renderer();
    marked.setOptions({
      renderer: rendererMD,
      highlight: function (code, lang) {
        // if (code.length > 2000) return code;
        if (lang && hljs.getLanguage(lang)) {
          return hljs.highlight(code, { language: lang }).value;
        }
        return code;
      },
      gfm: true,
      tables: true,
      breaks: true,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: true,
      langPrefix: "hljs language-",
    });
    // ---------------------------------------------------------------------

    this.loadPersonalization();
    if (this.is_restored && this.conversation_id != null) {
      // 提前进入聊天态布局：输入框直接落到底部，中间显示加载占位。否则会先渲染一帧
      // 居中的学术搜索欢迎页，等消息接口回来再跳成聊天态，观感上像"刷新跳回了首页"。
      this.greeting_label_show_state = false;
      this.user_input_move_to_bottom_state = true;
      this.conversation_restoring = true;
    }
    this.loadConversationData(this.conversation_id);

    this.scrollElement = this.$refs.scrollContainer;
    this.scrollElement.addEventListener("scroll", this.handleElementScroll);

    window.renderWorkbenchDataByIdx = this.renderWorkbenchDataByIdx;

    this.change_tool(this.tool_idx);

    // recentDisplayItems 通过 $refs 读 LeftBar.conversation_history，$refs 访问不会被
    // Vue 追踪为响应式依赖，computed 求值一次后就不会跟着数据刷新自动重算。这里订阅
    // LeftBar 刷新完成的广播，用一个真正响应式的计数器强制 computed 重新求值；同时立即
    // 补触发一次，覆盖 LeftBar 早于本组件挂载、数据已经就绪的情况(这时事件已经错过了)。
    EventBus.$on("conversationHistoryLoaded", this.bumpRecentQueriesTick);
    this.bumpRecentQueriesTick();
  },
  beforeDestroy() {
    this.scrollElement.removeEventListener("scroll", this.handleElementScroll);
    if (this.personalizationJournalSearchTimer) clearTimeout(this.personalizationJournalSearchTimer);
    delete window.renderWorkbenchDataByIdx;
    EventBus.$off("conversationHistoryLoaded", this.bumpRecentQueriesTick);
  },
  computed: {
    isAcademicWelcome() {
      return this.greeting_label_show_state && this.cur_tool_idx != null && this.tool_list[this.cur_tool_idx]["function"] == "academic_search";
    },
    academicSupportPrimaryLabels() {
      return this.supportedDirectQuestionTypeLabels.filter(item => item !== "文献定位");
    },
    activePersonalizationCount() {
      return this.personalizationDisciplines.length + this.personalizationJournals.length;
    },
    hasActivePersonalizationFilters() {
      return this.personalizationDisciplines.length > 0 || this.personalizationJournals.length > 0;
    },
    personalizationStatusLabel() {
      return this.personalizationSaved ? "已保存" : "本地保存";
    },
    // “最近查询”就是学术搜索最近的几条真实会话，直接读 LeftBar 已经加载好的
    // conversation_history(后端按 update_time 倒序返回)，不再用本地缓存维护一份
    // 影子数据——这样天然和真实会话同步，不会跟丢会话上下文，也不会被退出登录清空。
    recentDisplayItems() {
      // 读一下这个计数器，让它成为 computed 的响应式依赖(见 mounted 里的订阅注释)。
      void this.recentQueriesTick;
      const leftBarRef = this.getLeftBarRef();
      const history = leftBarRef && Array.isArray(leftBarRef.conversation_history) ? leftBarRef.conversation_history : [];
      const recent = history.filter(conv => conv && conv.type === "academic_search" && conv.conversation_id != null).slice(0, 3);
      if (!recent.length) return this.defaultRecentQueries;
      return recent.map(conv => ({
        text: conv.conversation_name,
        conversation_id: conv.conversation_id,
        time: this.formatRecentQueryTime(conv.update_time),
      }));
    },
    selectedPersonalizationDialogTitle() {
      return this.selectedPersonalizationDialogType === "disciplines" ? "已选 ESI 学科" : "已选期刊";
    },
    selectedPersonalizationEmptyText() {
      return this.selectedPersonalizationDialogType === "disciplines" ? "暂未选择学科" : "暂未选择期刊";
    },
    selectedPersonalizationItems() {
      const isDiscipline = this.selectedPersonalizationDialogType === "disciplines";
      const values = isDiscipline ? this.personalizationDisciplines : this.personalizationJournals;
      const options = isDiscipline ? this.personalizationDisciplineOptions : this.personalizationJournalOptions;
      const optionLabelMap = options.reduce((result, item) => {
        result[item.value] = item.label || item.value;
        return result;
      }, {});
      return values.map(value => ({
        value,
        label: optionLabelMap[value] || value,
      }));
    },
  },
  watch: {
    conversation_id(newVal, oldVal) {
      if (newVal == null || newVal === oldVal) return;
      this.loadConversationData(newVal);
    },
    tool_idx(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.change_tool(newVal);
    },
    user_input(newVal, oldVal) {
      if (newVal.trim()) {
        this.send_msg_btn_highlight_state = true;
      } else {
        this.send_msg_btn_highlight_state = false;
      }
    },
    bot_answer(newVal, oldVal) {
      if (!this.answer_scroll_move_up) this.scrollToBottom();
    },
    send_msg_btn_loading_state(newVal, oldVal) {
      this.answer_scroll_move_up = false;
    },
  },
  methods: {
    bumpRecentQueriesTick() {
      this.recentQueriesTick++;
    },
    // 与 defaultRecentQueries 里静态示例的时间格式保持一致：今天显示 HH:mm，
    // 昨天显示"昨天 HH:mm"，更早显示 MM-DD HH:mm。
    formatRecentQueryTime(updateTime) {
      if (!updateTime) return "";
      // 接口返回的是 ISO 8601 格式(如 2026-08-18T14:10:04)，各浏览器原生 Date 都能直接解析，
      // 不需要像 "yyyy-MM-dd HH:mm:ss" 那样为兼容 Safari 把 "-" 替换成 "/"。
      const d = new Date(updateTime);
      if (isNaN(d.getTime())) return "";
      const pad = n => String(n).padStart(2, "0");
      const hm = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
      const now = new Date();
      const isSameDay = date => date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate();
      if (isSameDay(d)) return hm;
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      if (d.getFullYear() === yesterday.getFullYear() && d.getMonth() === yesterday.getMonth() && d.getDate() === yesterday.getDate()) {
        return `昨天 ${hm}`;
      }
      return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${hm}`;
    },
    focusInput() {
      this.$nextTick(() => {
        const textarea = this.$el && this.$el.querySelector ? this.$el.querySelector(".user_input textarea") : null;
        if (textarea) textarea.focus();
      });
    },
    applyDirectQuestionTypePreset(label) {
      const presetMap = {
        趋势综述: "请总结 XXXX 的研究趋势",
        方法清单: "请梳理 XXXX 的代表性方法",
        对比分析: "请比较 A 与 B 在 XXXX 中的优缺点",
        机制解释: "请解释 XXXX 的作用机制",
        风险局限: "请分析 XXXX 的风险与局限",
        定义查询: "什么是 XXXX？",
        数值查询: "XXXX 是多少？",
        文献定位: "请输入论文标题、DOI 或强线索",
      };
      this.user_input = presetMap[label] || "";
      this.focusInput();
    },
    applyDirectAskExample(text) {
      this.stream_chat(text);
    },
    applyRecentQuery(item) {
      // 兼容旧调用方式：直接传字符串时按纯文本处理（无真实会话 id，等价于重新检索）。
      const text = typeof item === "string" ? item : item && item.text;
      const conversationId = typeof item === "object" && item ? item.conversation_id : null;
      if (!text) return;
      if (!conversationId) {
        // 没有真实 conversation_id(旧格式缓存、或示例问题)时，保持原行为重新发起一次检索。
        this.stream_chat(text);
        return;
      }
      // 恢复的是真实会话而不是伪造一段本地聊天记录：和点击左侧"历史记录"走同一条
      // change_conversation 链路，让 conversation_id 正确回填，后续追问才能带上
      // 这个会话的完整上下文去请求，而不是丢了上下文单独问一句。
      EventBus.$emit("change_conversation", conversationId, this.cur_tool_idx, this.tool_list, true);
    },
    handlePersonalizationOpen() {
      this.loadPersonalization();
      this.loadPersonalizationOptions();
    },
    loadPersonalization() {
      try {
        const raw = localStorage.getItem(PERSONALIZATION_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        this.personalizationDisciplines = Array.isArray(parsed.disciplines) ? parsed.disciplines : [];
        this.personalizationJournals = Array.isArray(parsed.journals) ? parsed.journals : [];
        this.personalizationSaved = true;
      } catch (e) {}
    },
    async loadPersonalizationOptions(keyword = "", force = false) {
      if (this.personalizationOptionsLoading) return;
      if (!force && this.personalizationOptionsLoaded && !keyword) return;
      this.personalizationOptionsLoading = true;
      if (keyword) this.personalizationJournalLoading = true;
      try {
        const response = await this.$http.get(this.globalUrl.research_personalization_options, {
          params: {
            keyword,
            limit: 100,
          },
        });
        const payload = response && response.data && response.data.data ? response.data.data : response.data;
        if (payload && Array.isArray(payload.disciplines)) {
          this.personalizationDisciplineOptions = payload.disciplines;
        }
        if (payload && Array.isArray(payload.journals)) {
          this.personalizationJournalOptions = payload.journals;
        }
        if (!keyword) this.personalizationOptionsLoaded = true;
      } catch (error) {
        // 当前主应用未提供 personalization-options 时，沿用 ai_search 分支的前端默认选项。
      } finally {
        this.personalizationOptionsLoading = false;
        this.personalizationJournalLoading = false;
      }
    },
    handlePersonalizationJournalSearch(keyword) {
      if (this.personalizationJournalSearchTimer) {
        clearTimeout(this.personalizationJournalSearchTimer);
      }
      const requestId = ++this.personalizationJournalSearchRequestId;
      this.personalizationJournalLoading = true;
      this.personalizationJournalSearchTimer = setTimeout(async () => {
        if (requestId !== this.personalizationJournalSearchRequestId) return;
        await this.loadPersonalizationOptions(keyword || "", true);
      }, 250);
    },
    schedulePersonalizationSave() {
      localStorage.setItem(
        PERSONALIZATION_KEY,
        JSON.stringify({
          disciplines: this.personalizationDisciplines,
          journals: this.personalizationJournals,
        }),
      );
      this.personalizationSaved = true;
    },
    clearPersonalizationFilters() {
      this.personalizationDisciplines = [];
      this.personalizationJournals = [];
      this.schedulePersonalizationSave();
    },
    showSelectedPersonalization(type) {
      this.selectedPersonalizationDialogType = type;
      this.selectedPersonalizationDialogVisible = true;
    },
    removeSelectedPersonalization(value) {
      if (this.selectedPersonalizationDialogType === "disciplines") {
        this.personalizationDisciplines = this.personalizationDisciplines.filter(item => item !== value);
      } else {
        this.personalizationJournals = this.personalizationJournals.filter(item => item !== value);
      }
      this.schedulePersonalizationSave();
    },
    buildPersonalizationFilters() {
      const filters = {};
      if (this.personalizationDisciplines.length) filters.disciplines = this.personalizationDisciplines;
      if (this.personalizationJournals.length) filters.journals = this.personalizationJournals;
      return filters;
    },
    buildPersonalizationFilterQuery(curToolName) {
      if (curToolName !== "academic_search" || !this.hasActivePersonalizationFilters) return "";
      return `&personalization_filters=${encodeURIComponent(JSON.stringify(this.buildPersonalizationFilters()))}`;
    },
    loadConversationData(conversation_id) {
      if (this.loadingConversationId === conversation_id || this.lastLoadedConversationId === conversation_id) {
        if (this.lastLoadedConversationId === conversation_id) this.conversation_restoring = false;
        return;
      }
      this.chat_history = [];
      this.topicDataContent = null;
      this.artAnalysisDataContent = null;
      this.full_txt_art_analysis_data = null;
      this.analysis_table_show_state = false;

      if (localStorage.getItem("token") && conversation_id != null) {
        this.loadingConversationId = conversation_id;
        this.select_conversation_one(conversation_id);
      } else {
        this.conversation_restoring = false;
      }
    },
    render_greeting_msg(greeting_msg, tip_msg) {
      if (this.$refs.childRefGreetingLabel) {
        this.$refs.childRefGreetingLabel.render_greeting_msg(greeting_msg, tip_msg);
      }
    },
    clossPaperAnalysis() {
      this.analysis_table_show_state = false;
      this.full_txt_art_analysis_data = null;
    },
    full_txt_art_analysis(data_ruid, file_name, is_create_task) {
      if (window) {
        history.pushState(null, "", "/asp/literature_analysis");
        const popStateEvent = new PopStateEvent("popstate", { state: null });
        window.dispatchEvent(popStateEvent);
      }
    },
    full_txt_art_analysis_by_task_data(task_data) {
      setTimeout(() => {
        this.analysis_table_show_state = true;
      }, 150);
      this.full_txt_art_analysis_data = task_data;
    },
    get_recent_upload() {
      this.$http.get(this.globalUrl.upload_recent).then(res => {
        this.upload_recent_list = res.data;
      });
    },
    word_segment_field_change(command) {
      // this.$message('click on item ' + command);
      this.cur_word_segment_field = command;
    },
    handleChatBoxClick(e) {
      if (this.findReferTarget(e)) return;
      this.activeItemId = null;
    },
    findReferTarget(e) {
      const target = e && e.target;
      if (!target || typeof target.closest !== "function") return null;
      return target.closest(".refer_art");
    },
    stripReferenceSection(answerMarkdown) {
      if (!answerMarkdown) return "";
      return String(answerMarkdown)
        .replace(/(^|\n)\s*#{1,6}\s*参考文献\s*\n[\s\S]*$/m, "$1")
        .replace(/(^|\n)\s*参考文献\s*\n\s*\[\d+\][\s\S]*$/m, "$1")
        .replace(/(^|\n)\s*\[(?:refer)?1\][^\n]*(?:(?:\n|\s+)\[(?:refer)?\d+\][^\n]*)+$/m, "$1")
        .trimEnd();
    },
    escapeHtmlAttr(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    // 统一净化：marked 4.x 已移除 sanitize，HTML 会直通。LLM 回答/论文摘要可能含恶意标签，
    // 一律经 DOMPurify 过滤后再交给 v-safe-html，防存储型 XSS。引用角标用的 label/data-* 在白名单内。
    renderSafeMarkdown(md) {
      const html = marked.parse(md == null ? "" : String(md));
      return DOMPurify.sanitize(html, {
        ADD_TAGS: ["label"],
        ADD_ATTR: ["target", "data-work_bench_idx", "data-refer_idx", "data-work_bench_data_idx", "data-q"],
      });
    },
    renderAnswerMarkdown(answerMarkdown) {
      return this.renderSafeMarkdown(this.stripReferenceSection(answerMarkdown));
    },
    renderAnswerWithReferences(answerMarkdown, referList) {
      const answerHtml = this.renderAnswerMarkdown(answerMarkdown);
      if (!Array.isArray(referList) || referList.length === 0) return answerHtml;
      return this.refer_format(referList, answerHtml);
    },
    refer_format(refer_list, bot_answer) {
      let work_bench_data_idx = this.work_bench_data_list.length - 1;
      const references = Array.isArray(refer_list) ? refer_list : [];
      return bot_answer.replace(/\[(?:refer)?(\d+)\]/g, (match, number) => {
        let index = number - 1;
        if (!references[index]) return match;
        let refer = references[index] || {};
        let title = this.escapeHtmlAttr(refer.title || refer.title_zh || `参考文献 ${number}`);
        return `<label class="refer_art" title="${title}" data-work_bench_idx="${work_bench_data_idx}" data-refer_idx="${index}">${number}</label>`;
      });
    },

    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(file, fileList) {},
    beforeRemove(file, fileList) {},
    handleUploadSuccess(res, files, fileList) {
      if (this.cur_tool_idx != null && this.tool_list[this.cur_tool_idx]["function"] == "full_txt_art_analysis") {
        if (res.code == -1) {
          this.$message.warning(res.msg);
          return;
        }

        this.fileList = [fileList[fileList.length - 1]];
        let data_ruid = res.data;
        this.full_txt_art_analysis(data_ruid, files.name, true);
      }
    },
    // --------------------------------------------------------------------------------------------------------------------------------

    change_widget_when_switching_tools(tool_name) {
      if (!tool_name) {
        this.user_input_show_state = true;
        this.input_submit_show_state = true;
        this.deepthink_btn_show_state = true;
        this.upload_btn_show_state = false;
        this.upload_tips = "";
        this.fileList = [];
        this.max_file_num = 1;
        this.accept_file_list = [".pdf"];
        this.render_greeting_msg(null, null);
        this.word_segment_field_show_state = false;
        this.cur_placeholder_txt = this.placeholder_default_txt;
      } else if (tool_name == "academic_search") {
        this.user_input_show_state = true;
        this.input_submit_show_state = true;
        this.deepthink_btn_show_state = true;
        this.upload_btn_show_state = false;
        this.upload_tips = "";
        this.fileList = [];
        this.max_file_num = 0;
        this.accept_file_list = [".pdf"];
        if (this.academic_search___random_q.length == 0) this.get_academy_q();
        this.render_greeting_msg(this.tool_list[this.cur_tool_idx]["label"], this.tool_list[this.cur_tool_idx]["intro"]);
        this.word_segment_field_show_state = false;
        this.cur_placeholder_txt = "输入研究问题、方法对比、概念解释或文献定位需求";
      } else if (tool_name == "word_segment_search") {
        this.cur_placeholder_txt = "请输入检索内容";
        return;
      } else if (tool_name == "full_txt_art_analysis") {
        this.$emit("closeWorkbench");
      } else if (tool_name == "ai_help" || tool_name == "pdf_translation" || tool_name == "literature_review") {
        this.navigateByToolFunction(tool_name);
        return;
      }

      // }
      else {
        this.user_input_show_state = true;
        this.input_submit_show_state = true;
        this.deepthink_btn_show_state = true;
        this.upload_btn_show_state = true;
        this.upload_tips = "";
        this.fileList = [];
        this.max_file_num = 0;
        this.accept_file_list = [".pdf"];
        this.render_greeting_msg(this.tool_list[this.cur_tool_idx]["label"], this.tool_list[this.cur_tool_idx]["intro"]);
        this.word_segment_field_show_state = false;
        this.cur_placeholder_txt = "";
      }
    },
    handleReferHover(e) {
      const referTarget = this.findReferTarget(e);
      if (!referTarget) {
        this.activeItemId = null;
        this.cur_hover_refer_idx = null;
        return;
      }
      let refer_idx = Number(referTarget.dataset.refer_idx);
      let work_bench_idx = Number(referTarget.dataset.work_bench_idx);
      const refer_id = `${work_bench_idx}-${refer_idx}`;
      if (refer_id == this.cur_hover_refer_idx) {
        this.activeItemId = refer_id;
        return;
      }
      const workBenchData = this.work_bench_data_list[work_bench_idx];
      const dataList = workBenchData && workBenchData.content && Array.isArray(workBenchData.content.data_list) ? workBenchData.content.data_list : [];
      const article = dataList[refer_idx];
      if (!article) {
        this.activeItemId = null;
        this.cur_hover_refer_idx = null;
        return;
      }
      this.cur_hover_refer_idx = refer_id;
      this.refer_hover_render(referTarget, refer_id, article);
    },
    refer_hover_render(target, refer_id, article) {
      const rect = target.getBoundingClientRect();
      const tooltipWidth = 360;
      const tooltipHeight = 320;
      const gap = 10;
      const padding = 12;
      let position = "right";
      let x = rect.right + gap;
      let y = rect.top + rect.height / 2;

      if (x + tooltipWidth > window.innerWidth - padding) {
        position = "left";
        x = rect.left - tooltipWidth - gap;
      }
      if (x < padding) {
        position = "bottom";
        x = Math.min(Math.max(rect.left - tooltipWidth / 2, padding), window.innerWidth - tooltipWidth - padding);
        y = rect.bottom + gap;
      }
      if (position !== "bottom") {
        y = Math.min(Math.max(y, padding + tooltipHeight / 2), window.innerHeight - padding - tooltipHeight / 2);
      }

      this.tooltipPosition = position;
      this.activeItemId = refer_id;
      this.currentItem = { id: refer_id, article: article };

      this.tooltipCoordinates = {
        x,
        y,
      };
    },
    handleBotAnswerClick(e) {
      const referTarget = this.findReferTarget(e);
      if (referTarget) {
        const workBenchDataIdx = Number(referTarget.dataset.work_bench_idx);
        if (!Number.isNaN(workBenchDataIdx) && this.work_bench_data_list[workBenchDataIdx]) {
          this.$emit("renderWorkbenchData", this.work_bench_data_list[workBenchDataIdx], workBenchDataIdx);
        }
        return;
      }
      if (e.target.classList.contains("reference_label")) {
        let work_bench_data_idx = e.target.dataset.work_bench_data_idx;
        this.$emit("renderWorkbenchData", this.work_bench_data_list[parseInt(work_bench_data_idx)], work_bench_data_idx);
      }
      if (e.target.classList.contains("extend_q_label")) {
        let q = e.target.dataset.q;
        this.stream_chat(q);
      }
    },
    select_conversation_one(conversation_id) {
      this.$http
        .get(this.globalUrl.cxai_conversation_select_one, { params: { conversation_id: conversation_id } })
        .then(res => {
          // todo
          let conv_data = res.data.conv_data;
          let conv_type = res.data.conv_type;
          this.topicDataContent = null;
          this.artAnalysisDataContent = null;

          if (conv_type == "task" && conv_data && conv_data["type"]) {
            const matchedToolIdx = this.tool_list.findIndex(item => item.function == conv_data["type"]);
            if (matchedToolIdx !== -1 && matchedToolIdx !== this.cur_tool_idx) {
              this.change_tool(matchedToolIdx);
            }
          }

          if (conv_type == "conv") {
            let aa = this.answer_render(conv_data);
            this.chat_history = aa;
            if (this.chat_history.length > 0) this.chat_mode_start();
          } else if (conv_type == "task") {
            if (conv_data["type"] == "topic_selection_assistance") this.topicDataContent = conv_data["result"];
            else if (conv_data["type"] == "full_txt_art_analysis") this.artAnalysisDataContent = conv_data["result"];
          }
          this.lastLoadedConversationId = conversation_id;
        })
        .finally(() => {
          if (this.loadingConversationId === conversation_id) {
            this.loadingConversationId = null;
          }
          if (this.conversation_restoring && String(this.conversation_id) === String(conversation_id)) {
            this.conversation_restoring = false;
            // 会话查不到内容（已被清空或接口出错）时把欢迎页放回来，别留一个空壳页面。
            if (!this.chat_history.length && !this.topicDataContent && !this.artAnalysisDataContent) {
              this.greeting_label_show_state = true;
              this.user_input_move_to_bottom_state = false;
            }
          }
        });
    },

    render_user_input(user_input) {
      // 用户提问同样经 v-safe-html 渲染，转义避免 <img onerror> 等注入（自 XSS/历史回显）。
      const safe = this.escapeHtmlAttr(user_input);
      return `<div style="width:100%; display: flex; flex-direction: row; justify-content: end;">
                <div class="user_ask">
                    ${safe}
                </div>
              </div>`;
    },
    render_process(process_str) {
      return '<div class="process"><i class="el-icon-location-outline"></i>' + process_str + "</div>";
    },
    render_trace_panel(steps) {
      if (!steps || !steps.length) return "";
      const esc = s =>
        String(s == null ? "" : s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      const dotClass = status => {
        const failed = status === "failed";
        const running = status !== "done" && status !== "failed";
        return failed ? "rag-trace-dot failed" : running ? "rag-trace-dot running" : "rag-trace-dot done";
      };
      const renderLines = lines => {
        let html = "";
        for (const line of lines || []) {
          if (!line) continue;
          html += '<div class="rag-trace-line">' + esc(line) + "</div>";
        }
        return html;
      };
      // 检索阶段下的子步骤（关键词/向量/融合/重排…），构成第三层层次
      const renderChildren = children => {
        if (!children || !children.length) return "";
        let items = "";
        for (const child of children) {
          items += '<div class="rag-trace-subitem">' + '<div class="rag-trace-subhead"><span class="' + dotClass(child.status) + '"></span><span class="rag-trace-subtitle">' + esc(child.title) + "</span></div>" + renderLines(child.lines) + "</div>";
        }
        return '<div class="rag-trace-children">' + items + "</div>";
      };

      const allDone = steps.every(s => s.status === "done" || s.status === "failed");
      const doneCount = steps.filter(s => s.status === "done" || s.status === "failed").length;
      const summaryText = allDone ? "检索过程" : "检索中…";

      let items = "";
      for (const step of steps) {
        const detail = renderLines(step.lines) + renderChildren(step.children);
        const hasDetail = !!detail;
        const head = '<span class="' + dotClass(step.status) + '"></span>' + '<span class="rag-trace-title">' + esc(step.title) + "</span>" + (hasDetail ? '<i class="rag-trace-caret el-icon-arrow-right"></i>' : "");
        if (hasDetail) {
          items +=
            // 每个步骤默认展开，参数(小项目)直接可见，无需逐个点击；用户仍可手动收起
            '<details class="rag-trace-step" open>' + '<summary class="rag-trace-head">' + head + "</summary>" + '<div class="rag-trace-detail">' + detail + "</div>" + "</details>";
        } else {
          items += '<div class="rag-trace-step is-leaf"><div class="rag-trace-head">' + head + "</div></div>";
        }
      }
      const openAttr = allDone ? "" : " open";
      return (
        '<details class="rag-trace"' +
        openAttr +
        ">" +
        '<summary class="rag-trace-summary"><i class="el-icon-cpu"></i><span>' +
        summaryText +
        "</span>" +
        '<span class="rag-trace-progress">' +
        doneCount +
        "/" +
        steps.length +
        "</span></summary>" +
        '<div class="rag-trace-body">' +
        items +
        "</div>" +
        "</details>"
      );
    },
    render_search_condition(condition_dict) {
      let render_res = "";
      render_res += `<div class="condition">`;
      if (!allValuesEmpty(condition_dict)) {
        render_res += `<div style="color: var(--label-color2); font-weight: 500;">识别到您的检索条件为</div>`;
        render_res += `<div style="display: flex; flex-wrap: wrap; gap: 1.5rem; align-items: center; margin: 0;">`;
        for (const key in condition_dict) {
          let value = condition_dict[key];
          if (value != "" && value != null) {
            render_res +=
              `<div style="display: flex; align-items: center; gap: 0.5rem;">
                                <span style="color: var(--label-color2); ">` +
              key +
              `:</span>
                                <span style="color: var(--blue); font-weight: 500;">` +
              value +
              `</span>
                            </div>`;
          }
        }
        render_res += `</div>`;
      } else {
        render_res += `<p style="margin: 0; color: #666; font-weight: 500;">未识别到检索条件</p>`;
      }
      render_res += "</div>";
      return render_res;
    },
    render_data_show_btn(type, data_dict) {
      // data_dict = JSON.parse(data_dict)
      let data_num = data_dict["total"];
      let data_list = data_dict["data_list"];

      let work_bench_data = null;
      if (type == "word_segment_search_res") {
        let search_dict = data_dict["search_dict"];
        work_bench_data = { type: type, content: data_dict, search_dict: search_dict };
      } else work_bench_data = { type: type, content: data_dict };

      this.work_bench_data_list.push(work_bench_data);
      let work_bench_data_idx = this.work_bench_data_list.length - 1;
      let render_res = "";
      if (data_num > 0) {
        render_res =
          `<div>
                          <span class="reference_label" data-work_bench_data_idx="` +
          work_bench_data_idx +
          `" style="font-size:14px; margin: 5px; display: inline-block; padding:5px 10px; cursor: pointer; background-color: var(--label-bg); color:var(--label-color); border-radius:10px; border:1px solid var(--label-border);">
                            <i class="reference_label el-icon-link" data-work_bench_data_idx="` +
          work_bench_data_idx +
          `"></i>
                            找到
                            <span class="reference_label" data-work_bench_data_idx="` +
          work_bench_data_idx +
          `" style="color:var(--blue)"> ` +
          data_num +
          ` </span>
                            篇资料
                            <i class="reference_label el-icon-arrow-right" data-work_bench_data_idx="` +
          work_bench_data_idx +
          `"></i>
                          </span>
                        </div>`;
      }

      return [render_res, work_bench_data_idx, work_bench_data, data_list];
    },
    render_think(think_md_str) {
      return '<div style="background-color: var(--bg-front); color:var(--label-color); border-radius:10px; padding:10px 10px 10px 25px;">' + this.renderSafeMarkdown(think_md_str) + "</div>";
    },
    render_extend_q(extend_q_list) {
      let render_res = '<div style="margin-top: 10px">';
      for (let i = 0; i < extend_q_list.length; i++) {
        let extend_q = extend_q_list[i];
        render_res +=
          `<div>
                        <span class="extend_q_label" data-q="` +
          extend_q +
          `" style="cursor: pointer; color:#888; font-size: 14px;">
                          ` +
          extend_q +
          `
                          <i class="el-icon-right"></i>
                        </span>
                      </div>`;
      }
      render_res += "</div>";
      return render_res;
    },
    render_disclaimer(disclaimer) {
      return '<div class="disclaimer">' + disclaimer + "</div>";
    },
    // -----------------------------------------------------------------------------------------------------------------------------------------------------------

    close_tool() {
      this.cur_tool_idx = null;
      setTimeout(() => {
        this.change_widget_when_switching_tools(null);
      }, 100);
    },
    getLeftBarRef() {
      return findLeftBarRef(this);
    },
    navigateByToolFunction(toolFunction) {
      const directRouteMap = {
        word_segment_search: "/literatureSearch",
        full_txt_art_analysis: "/asp/literature_analysis",
        topic_selection_assistance: "/topic-assistant",
        literature_review: "/asp/literature_review",
        pdf_translation: "/asp/translation",
        ai_help: "/AiHelp",
      };
      const targetPath = toolFunction ? directRouteMap[toolFunction] : null;

      if (targetPath && window) {
        history.pushState(null, "", targetPath);
        const popStateEvent = new PopStateEvent("popstate", { state: null });
        window.dispatchEvent(popStateEvent);
        return true;
      }

      return false;
    },
    handleTool(idx) {
      const selectedToolFunction = this.tool_list[idx] ? this.tool_list[idx].function : null;
      if (!localStorage.getItem("token")) {
        this.authUtils.getOrgUrl().then(url => {
          window.location.href = url;
        });
        return;
      }
      if (this.tool_list[idx].function == "full_txt_art_analysis" || this.tool_list[idx].function == "topic_selection_assistance" || this.tool_list[idx].function == "pdf_translation" || this.tool_list[idx].function == "literature_review" || this.tool_list[idx].function == "academic_search") {
        if (localStorage.getItem("ip_user") == 1) {
          this.authUtils.getOrgUrl().then(url => {
            window.location.href = url;
          });
          return;
        }
      }

      const leftBarRef = this.getLeftBarRef();
      if (leftBarRef && typeof leftBarRef.add_conversation === "function") {
        leftBarRef.add_conversation(idx, this.tool_list, true);
        return;
      }

      this.change_tool(idx);
    },
    change_tool(idx) {
      if (idx == null) {
        const academicSearchToolIndex = this.tool_list.findIndex(tool => tool && tool.function === "academic_search");
        if (academicSearchToolIndex >= 0) {
          idx = academicSearchToolIndex;
        }
      }
      if (idx != null && this.navigateByToolFunction(this.tool_list[idx].function)) {
        return;
      }
      this.cur_tool_idx = idx;
      // if(this.tool_list[this.cur_tool_idx]['function']=='academic_search') {}
      this.change_widget_when_switching_tools(this.cur_tool_idx != null ? this.tool_list[this.cur_tool_idx]["function"] : null);
    },
    get_academy_q() {
      if (!localStorage.getItem("token")) {
        this.academic_search___random_q = [];
        return;
      }
      this.$http.get(this.globalUrl.academic_search___random_q).then(res => {
        this.academic_search___random_q = res.data;
      });
    },
    get_word_segment_search___random_q() {
      if (!localStorage.getItem("token")) {
        this.authUtils.getOrgUrl().then(url => {
          window.location.href = url;
        });
        return;
      }
      this.$http.get(this.globalUrl.word_segment_search___random_q).then(res => {
        this.word_segment_search___random_q = res.data;
      });
    },
    handleElementScroll() {
      let newVal = this.scrollElement.scrollTop;
      let oldVal = this.elementScrollTop;
      if (this.send_msg_btn_loading_state && newVal < oldVal) {
        this.answer_scroll_move_up = true;
      }
      this.elementScrollTop = this.scrollElement.scrollTop;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    chat_mode_start() {
      this.greeting_label_show_state = false;
      this.user_input_move_to_bottom_state = true;
      this.scrollToBottom();
    },
    handleKeyDown(event) {
      if (event.shiftKey) {
        return true;
      } else {
        this.stream_chat(this.user_input);
        event.preventDefault();
      }
    },

    answer_render(chat_history) {
      let new_chat_history = [];
      // 多轮会话只打开最后一次检索的结果，与离开页面前看到的一致
      let last_work_bench = null;
      for (let i = 0; i < chat_history.length; i++) {
        let ch = chat_history[i];
        if (ch.role == "user") ch.content = this.render_user_input(ch.content);
        else if (ch.role == "assistant") {
          let content_format = "";
          let content_list = JSON.parse(ch["content"]);
          let reference = null;
          let answer = null;
          for (let i = 0; i < content_list.length; i++) {
            let message = content_list[i];

            if (message.type == "process") content_format += this.render_process(message.content);
            else if (message.type == "word_segment_search_condition") content_format += this.render_search_condition(message.content);
            else if (message.type == "reference" || message.type == "word_segment_search_res") {
              let [render_res, work_bench_data_idx, work_bench_data, data_list] = this.render_data_show_btn(message.type, message.content);
              content_format += render_res;
              if (message.type == "reference" && data_list.length > 0) reference = data_list;
              // 记下最后一次检索结果，循环结束后打开工作台。流式路径收到 reference 时会
              // 立刻 emit renderWorkbenchData，回显路径原本漏了这一步，于是刷新后右侧文献
              // 列表空白——数据其实已经进了 work_bench_data_list，只是没人通知面板打开。
              last_work_bench = { data: work_bench_data, idx: work_bench_data_idx };
            } else if (message.type == "think") content_format += this.render_think(message.content);
            else if (message.type == "answer") {
              content_format += this.renderAnswerWithReferences(message.content, reference);
              if (message.content != "" && message.content != null) answer = message.content;
            } else if (message.type == "extend_q") {
              let extend_q_list = JSON.parse(message.content);
              content_format += this.render_extend_q(extend_q_list);
            } else if (message.type == "disclaimer") {
              content_format += this.render_disclaimer(message.content);
            }
          }

          if (reference != null && answer != null) content_format = this.refer_format(reference, content_format);
          ch.content = content_format;
        }

        new_chat_history.push(ch);
      }

      // 用专用事件而不是 renderWorkbenchData：后者带 toggle 语义（同一 idx 再次调用会关闭
      // 面板），恢复场景要的是"确保打开"，语义不同，混用会在重复回显时把面板又关掉。
      if (last_work_bench) this.$emit("restoreWorkbenchData", last_work_bench.data, last_work_bench.idx);

      return new_chat_history;
    },
    stream_chat_flow(q_id, question) {
      if (!localStorage.getItem("token")) {
        this.authUtils.getOrgUrl().then(url => {
          window.location.href = url;
        });
        return;
      }
      let cur_tool_name = this.cur_tool_idx != null ? this.tool_list[this.cur_tool_idx]["function"] : null;
      // 学术搜索不再拼接"学术搜索: "前缀：该前缀此前会被当成实际检索问题一并发给
      // ragsearch(见下方 question 直接作为 &question= 参数),纯属展示遗留文本,
      // 对检索无意义,徒增噪声;气泡本身已用专属配色区分学术搜索场景,无需再靠前缀文字标识。
      if (cur_tool_name == "word_segment_search") {
        if (this.cur_word_segment_field == "智能判断") question = `文献检索: ${question}`;
        else question = `文献检索: ${this.cur_word_segment_field}=>${question}`;
      }
      // -----------------------------------------------------------------------------------------

      this.send_msg_btn_loading_state = true;
      this.chat_mode_start();
      this.uesr_question = question;
      this.user_input = "";
      this.bot_answer = "";
      this.chat_history.push({ role: "user", content: this.render_user_input(this.uesr_question) });
      this.chat_history.push({ role: "assistant", content: "" });

      let send_q = q_id != null ? null : question;
      const streamUrl = cur_tool_name == "academic_search" ? this.globalUrl.rag_stream_chat : this.globalUrl.stream_chat;
      const baseQuery = `?conversation_id=${this.conversation_id}` + (q_id ? `&q_id=${q_id}` : `&q_id=`) + (send_q ? `&question=${encodeURIComponent(send_q)}` : `&question=`) + `&is_deep_think=${this.deepthink_on_state ? "on" : "off"}` + this.buildPersonalizationFilterQuery(cur_tool_name);
      let this_ = this;
      // ③ 流式走 EventSource，它带不了 Authorization 头，凭据只能进 URL。这里一律换成
      //    一次性短时效 ticket，绝不把长期 token 拼进 URL：URL 会落进浏览器历史、网关
      //    access log 和 Referer，而 token 有效期 3 天，payload 里还带着邮箱、姓名和
      //    密码哈希。换票失败时直接报错，不再降级用 token —— 泄露凭据远比一次提问失败严重。
      const startStream = authQuery => {
        const eventSource = new EventSource(streamUrl + baseQuery + authQuery);

        setTimeout(function () {
          this_.$emit("updateConversationHistory");
        }, 1000);
        // ---------------------------------------------------------------------------------------

        let think_bf = "";
        let answer_bf = "";
        let think_md_cache = "";
        let answer_md_cache = "";
        let last_type = "";
        let reference = null;
        let streamEnded = false;
        // trace 面板始终作为助手消息的固定前缀（trace_html），其余内容累积到 tail，
        // 最终 bot_answer = trace_html + tail。这样后到的 trace 事件（如 rag_answer、
        // 夹在 reference 之间的阶段）只更新前缀，不会与正文重复或错位。
        let trace_html = "";
        let tail = "";
        let trace_steps = [];
        let lastAnswerRender = 0; // ④ 答案渲染节流时间戳
        const compose = () => {
          this_.bot_answer = trace_html + tail;
        };
        eventSource.onmessage = function (event) {
          const message = JSON.parse(event.data);

          if (message.type == "trace" || message.type == "trace_replay") {
            if (message.type == "trace") {
              let step = { stage: message.stage || "", status: message.status || "", title: message.title || "", lines: message.lines || [], children: [] };
              let idx = step.stage ? trace_steps.findIndex(s => s.stage === step.stage) : -1;
              if (idx >= 0) {
                // 同一 stage 的 running->done 更新：保留已挂载的子步骤
                step.children = trace_steps[idx].children || [];
                trace_steps.splice(idx, 1, step);
              } else trace_steps.push(step);
            } else {
              // trace_replay：把检索子步骤挂到父阶段（默认 retrieval）下，形成第三层层次
              const parentStage = message.parent || "retrieval";
              const children = (message.events || []).map(e => ({ stage: e.stage || "", status: e.status || "", title: e.title || "", lines: e.lines || [] }));
              let pidx = trace_steps.findIndex(s => s.stage === parentStage);
              if (pidx >= 0) trace_steps[pidx] = Object.assign({}, trace_steps[pidx], { children: children });
            }
            trace_html = this_.render_trace_panel(trace_steps);
            compose();
          } else if (message.type == "process") {
            tail += this_.render_process(message.content);
            compose();
          } else if (message.type == "word_segment_search_condition") {
            tail += this_.render_search_condition(message.content);
            compose();
          } else if (message.type == "reference" || message.type == "word_segment_search_res") {
            let [render_res, work_bench_data_idx, work_bench_data, data_list] = this_.render_data_show_btn(message.type, message.content);
            tail += render_res;
            compose();
            if (message.type == "reference" && data_list.length > 0) reference = data_list;
            // if(message.type=='word_segment_search_res') this_.$emit('renderWorkbenchData', work_bench_data, work_bench_data_idx)
            this_.$emit("renderWorkbenchData", work_bench_data, work_bench_data_idx);
          } else if (message.type == "think") {
            if (last_type != "think") think_bf = tail;
            think_md_cache += message.content;
            tail = think_bf + this_.render_think(think_md_cache);
            compose();
          } else if (message.type == "answer") {
            if (last_type != "answer") {
              answer_bf = tail;
              answer_md_cache = "";
            }
            answer_md_cache += message.content;
            // ④ 节流：分片累积进 cache，但至多每 80ms 才重跑一次 marked+整段渲染，避免 O(n²) 卡顿；
            // end 事件里会强制做最终渲染，保证完整。
            const nowTs = Date.now();
            if (nowTs - lastAnswerRender >= 80) {
              lastAnswerRender = nowTs;
              tail = answer_bf + this_.renderAnswerWithReferences(answer_md_cache, reference);
              compose();
            }
          } else if (message.type == "conversation") {
            // ⑦ 后端在新建会话时回传其分配的 conversation_id；若本次是以空 id 发起，回填给上层，避免下一轮另起会话。
            try {
              const convInfo = typeof message.content === "string" ? JSON.parse(message.content) : message.content;
              const resolvedId = convInfo && convInfo.conversation_id;
              if (resolvedId && !this_.conversation_id) this_.$emit("conversationIdResolved", resolvedId);
            } catch (e) {
              /* 忽略解析失败 */
            }
          } else if (message.type == "extend_q") {
            let extend_q_list = JSON.parse(message.content);
            tail += this_.render_extend_q(extend_q_list);
            compose();
          } else if (message.type == "disclaimer") {
            tail += this_.render_disclaimer(message.content);
            compose();
          } else if (message.type == "end") {
            streamEnded = true;
            this_.send_msg_btn_loading_state = false;
            // 收尾：把仍处于 running 的 trace 步骤（如已接收/回答生成）标记为 done，让面板可收起
            let traceFinalized = false;
            for (const s of trace_steps) {
              if (s.status !== "done" && s.status !== "failed") {
                s.status = "done";
                traceFinalized = true;
              }
            }
            if (traceFinalized) trace_html = this_.render_trace_panel(trace_steps);
            if (answer_md_cache) tail = answer_bf + this_.renderAnswerWithReferences(answer_md_cache, reference);
            compose();

            this_.$emit("updateConversationHistory");
            eventSource.close();
            // ------------------------------------------------------
          }

          this_.chat_history[this_.chat_history.length - 1]["content"] = this_.bot_answer;
          last_type = message.type;
        };

        eventSource.onerror = function (error) {
          if (streamEnded) {
            eventSource.close();
            return;
          }
          this_.send_msg_btn_loading_state = false;
          console.error("EventSource failed:", error);
          eventSource.close();
          // ⑤ RAG 流非幂等（重连会重跑 LLM、重复计费），不自动重连；给用户明确反馈+可手动重试。
          if (this_.$message) this_.$message.error("检索连接中断，请重新提问");
          tail += '<div style="margin:8px 10px;padding:8px 12px;border-radius:8px;background:rgba(245,108,108,0.12);color:#f56c6c;font-size:13px;">⚠ 连接中断，本次回答可能不完整，请重新提问。</div>';
          compose();
          this_.chat_history[this_.chat_history.length - 1]["content"] = this_.bot_answer;
        };
      }; // end startStream

      // 两条流式通道（学术搜索 /rag/stream 与其余 /academic_search/stream）都走 ticket。
      // 端点固定取 globalUrl.stream_ticket，不再从 streamUrl 推导 —— 之前用
      // streamUrl.replace(/\/stream$/, "/stream-ticket") 推导，非 RAG 流会拼出并不存在的
      // /academic_search/stream-ticket。中间件识别 ticket 不限路径，共用一个端点即可。
      this.$http
        .post(this.globalUrl.stream_ticket)
        .then(res => {
          // 主应用响应拦截器已经解过一层 response.data，而该端点返回的是裸 {ticket}，
          // 不是项目里通行的 {data, code, msg}。两种位置都认一下，免得后端哪天改成统一
          // 包装时又变成取不到值、静默退回明文 token（这正是之前 ticket 形同虚设的原因）。
          const ticket = (res && res.ticket) || (res && res.data && res.data.ticket);
          if (!ticket) throw new Error("stream ticket missing");
          startStream(`&ticket=${encodeURIComponent(ticket)}`);
        })
        .catch(() => {
          this_.send_msg_btn_loading_state = false;
          if (this_.$message) this_.$message.error("鉴权失败，请重新提问");
          this_.chat_history[this_.chat_history.length - 1]["content"] = '<div style="margin:8px 10px;padding:8px 12px;border-radius:8px;background:rgba(245,108,108,0.12);color:#f56c6c;font-size:13px;">鉴权失败，请重新提问。</div>';
        });
    },
    recordSearchLog(searchWord) {
      const jyxToken = localStorage.getItem("jyx_token") || "";
      this.$http
        .post(
          this.globalUrl.search_log_record,
          { searchWord: searchWord },
          {
            headers: {
              Authorization: jyxToken,
            },
          },
        )
        .catch(error => {
          console.warn("record search log failed:", error);
        });
    },
    stream_chat(question) {
      if (!question.trim()) return;

      this.recordSearchLog(question.trim());

      let q_id = null;
      let this_ = this;
      let longTxtFlag = checkTextLength(question);
      if (longTxtFlag) {
        this.$http.post(this.globalUrl.long_question_cache, { question: question }).then(res => {
          q_id = res.data;
          this_.stream_chat_flow(q_id, question);
        });
      } else {
        this.stream_chat_flow(q_id, question);
      }
    },
  },
};
</script>

<style scoped>
.textarea_send-disabled__GF_p1 {
  color: #e5e6eb;
}
.text-color-primary {
  color: #1a76d8;
  cursor: pointer;
}
.user_input {
  margin-bottom: 15px;
  box-shadow: rgba(57, 141, 238, 0.12) 0px 0px 18px 0px;
}
.user_input :deep(.el-textarea__inner) {
  /* background-color: #eee !important; */
  /* 隐藏边框 */
  border: none !important;
  /* 去除聚焦时的默认轮廓 */
  outline: none !important;
  /* padding: 8px 12px; */
  /* background-color: #f5f5f5; */
  font-size: 16px !important;
  /* width: 100%; */
  max-width: 800px;
  resize: none !important;
  overflow-y: scroll;
  /* 闅愯棌婊氬姩鏉?*/
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  background-color: var(--bg-front);
  color: var(--txt-color);
}

.user_input :deep(.el-textarea__inner)::-webkit-scrollbar {
  display: none;
  background-color: var(--bg-front);
}

.user_chat {
  /* text-align: right; */
  margin-top: 50px;
  width: 100%;
}
.bot_chat {
  margin-top: 50px;
}
::v-deep .bot_chat {
  color: #172033;
  font-size: 15px;
  line-height: 1.82;
  word-break: break-word;
}
::v-deep .bot_chat p {
  margin: 0 0 10px;
}
::v-deep .bot_chat h1,
::v-deep .bot_chat h2,
::v-deep .bot_chat h3,
::v-deep .bot_chat h4 {
  margin: 18px 0 10px;
  color: #10203f;
  font-weight: 700;
  line-height: 1.4;
}
::v-deep .bot_chat h1 {
  font-size: 22px;
}
::v-deep .bot_chat h2 {
  font-size: 19px;
}
::v-deep .bot_chat h3 {
  font-size: 17px;
}
::v-deep .bot_chat ul,
::v-deep .bot_chat ol {
  margin: 8px 0 12px;
  padding-left: 24px;
}
::v-deep .bot_chat li {
  margin: 5px 0;
  padding-left: 2px;
}
::v-deep .bot_chat strong {
  color: #0f1f3d;
  font-weight: 700;
}
::v-deep .bot_chat a {
  color: var(--a-color);
  text-decoration: none;
}
::v-deep .bot_chat a:hover {
  text-decoration: underline;
}
::v-deep .bot_chat blockquote {
  margin: 10px 0;
  padding: 8px 12px;
  border-left: 3px solid #9fc0ff;
  border-radius: 0 6px 6px 0;
  color: #40516d;
  background: #f6f9ff;
}
::v-deep .bot_chat table {
  width: 100%;
  margin: 12px 0;
  border-collapse: collapse;
  font-size: 14px;
  background: #fff;
}
::v-deep .bot_chat th,
::v-deep .bot_chat td {
  padding: 8px 10px;
  border: 1px solid #dbe7f7;
  text-align: left;
}
::v-deep .bot_chat th {
  color: #10203f;
  background: #f4f8ff;
  font-weight: 700;
}
::v-deep .bot_chat code {
  padding: 2px 5px;
  border-radius: 4px;
  color: #0f4ca3;
  background: #eef5ff;
  font-size: 13px;
}
::v-deep .bot_chat pre {
  margin: 12px 0;
  padding: 12px;
  overflow-x: auto;
  border-radius: 8px;
  background: #0f172a;
}
::v-deep .bot_chat pre code {
  padding: 0;
  color: #e5edf8;
  background: transparent;
}
.model-select_model {
  height: 36px;
  padding: 0px 13px;
  background-color: #f2f3f5;
  border: 0.5px solid #e5e6eb;
  border-radius: 100px;
  display: flex;
  align-items: center;
}
.input-tools-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.input-tools-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}
.customization-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  padding: 0 !important;
  margin-left: 0;
  border-color: #d7e8ff;
  color: var(--a-color, #1677ff);
  background: #f7fbff;
  vertical-align: top;
  line-height: 1;
}
.customization-button ::v-deep span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: 1;
}
.customization-button i {
  margin: 0;
  font-size: 16px;
  line-height: 1;
}
.customization-button:hover,
.customization-button.is-active {
  border-color: var(--a-color, #1677ff);
  color: #fff;
  background: var(--a-color, #1677ff);
}
.model-select_model_flex {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.model-select_model_flex:first-of-type {
  margin-right: 10px;
}
.model-active_model {
  color: #1a76d8;
  background-color: #fff;
  border-radius: 100px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08);
  font-weight: 500;
  padding: 2px 10px;
}
.dp-build-icon {
  margin-right: 5px;
}
.deepthink_on {
  font-size: 14px;
  padding: 7px 15px;
  border-radius: 30px;
  border: 1px solid var(--btn-border-hover);
  color: #fff;
  background: var(--btn-bg-hover2);
  cursor: pointer;
  line-height: 20px;
  overflow: hidden;
}
.deepthink_off {
  font-size: 14px;
  padding: 7px 15px;
  border-radius: 30px;
  border: 1px solid var(--btn-border);
  color: var(--btn-color);
  background: var(--bg-btn);
  cursor: pointer;
  line-height: 20px;
}
.icon_small {
  font-size: 20px !important;
  font-weight: bold !important;
  padding: 6px !important;
  line-height: 20px;
}
/* .icon_mid {
  font-size: 20px; 
  font-weight: bold; 
  padding: 6px;
} */
.conversation-restoring {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  min-height: 200px;
  color: #8b95a7;
  font-size: 14px;
}
.chat_box {
  width: 100%;
  padding: 10px 0;
  /* max-height: 70vh;  */
  overflow-y: scroll;
  /* 闅愯棌婊氬姩鏉?*/
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}
.chat_box::-webkit-scrollbar {
  display: none;
}
.tool_label {
  position: absolute;
  align-self: flex-start;
  padding: 5px 20px;
  left: -20px;
  /* border-radius: 10px; */
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  background-color: var(--bg-front);
  z-index: 999;
  color: var(--btn-color-hover);
  cursor: pointer;
  /* 鍙充笅娣￠槾褰憋紙#00000026 = 榛戣壊 + 15%涓嶉€忔槑搴︼級 */
  box-shadow: 3px 3px 8px var(--shadow-color);
}
.chat-main-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: min(100%, 1180px);
  max-width: 1180px;
  margin: auto;
  margin-bottom: 0;
  box-sizing: border-box;
  padding-bottom: 0;
}
.chat-main-shell.is-welcome {
  height: auto;
  min-height: 620px;
  width: min(calc(100vw - 360px), 1180px);
  min-width: 900px;
}
.chat-main-shell > div:nth-child(2) {
  height: 100% !important;
  box-sizing: border-box;
}
.chat-main-shell:not(.is-welcome) > div:nth-child(2) {
  padding-bottom: 18px !important;
}
.chat-main-shell:not(.is-welcome) .user_input {
  flex: 0 0 auto;
  margin-bottom: 8px;
}
.tool_intro_box {
  /* height: 220px; */
  min-height: 120px;
  box-sizing: border-box;
  overflow: hidden;
  /* margin-bottom: 15px; */
}
.academic-assist-panel {
  margin: 12px 18px 20px;
  padding: 22px 0 0;
  border-top: 1px solid #e6eef9;
  background: transparent;
}
.assist-type-row {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 24px;
}
.assist-label {
  flex: 0 0 auto;
  font-size: 15px;
  font-weight: 700;
  color: #10203f;
  white-space: nowrap;
}
.assist-items {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 14px;
  min-width: 0;
}
.assist-chip {
  height: 36px;
  line-height: 34px;
  border-radius: 18px;
  padding: 0 18px;
  color: #1261df;
  border-color: #cfe0ff;
  background: #f7fbff;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.06);
}
.support-chip {
  max-width: 110px;
}
.assist-chip:hover {
  color: #fff;
  border-color: #246bfe;
  background: #246bfe;
}
.question-guide-trigger {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 2px;
  color: #1261df;
  border: 0;
  background: transparent;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}
.question-guide-trigger:hover,
.question-guide-trigger:focus {
  color: #0b55c8;
  text-decoration: underline;
  background: transparent;
}
.assist-content-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(340px, 1fr);
  gap: 30px;
  padding-top: 22px;
  border-top: 1px solid #e6eef9;
}
.assist-list-section {
  min-width: 0;
}
.assist-list-section.recent-section {
  padding-left: 30px;
  border-left: 1px solid #e6eef9;
}
.assist-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  margin-bottom: 14px;
  color: #10203f;
  font-size: 16px;
}
.assist-list-item {
  width: 100%;
  height: 48px;
  margin-bottom: 10px;
  padding: 0 14px;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 10px;
  border: 1px solid #dde8f6;
  border-radius: 10px;
  background: #fff;
  color: #10203f;
  cursor: pointer;
  text-align: left;
  box-shadow: 0 4px 14px rgba(27, 54, 93, 0.04);
}
.recent-section .assist-list-item {
  grid-template-columns: 24px minmax(0, 1fr);
}
.assist-list-item i:first-child {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #246bfe;
  background: #eef5ff;
}
.assist-list-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
.assist-list-item .el-icon-arrow-right {
  color: #6b7890;
}
.assist-list-item:hover {
  border-color: #9fc0ff;
  background: #f8fbff;
}
.assist-empty {
  height: 48px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  color: #8a94a6;
  border: 1px dashed #d7e1ef;
  border-radius: 10px;
  background: #fbfdff;
}
@media (max-width: 1280px) {
  .chat-main-shell.is-welcome {
    width: calc(100vw - 260px);
    min-width: 0;
  }
  .assist-content-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .assist-list-section.recent-section {
    padding-left: 0;
    border-left: 0;
    border-top: 1px solid #e6eef9;
    padding-top: 18px;
  }
}
.tool_intro_btn {
  margin: 5px;
  margin-left: 0 !important;
  max-width: 760px;
  min-width: 110px;
  white-space: nowrap; /* 强制文本单行显示 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis;
}
.direct-ask-guide {
  max-height: 360px;
  overflow-y: auto;
}
.direct-ask-guide-header {
  margin-bottom: 10px;
  color: var(--txt-color, #1f2937);
}
.direct-ask-guide-section {
  margin-bottom: 12px;
}
.direct-ask-guide-title {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  color: var(--txt-color2, #475569);
}
.direct-ask-guide-examples {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.direct-ask-guide-tag {
  max-width: 100%;
}
.personalization-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 2px 0 0;
}
.personalization-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #101828;
  font-size: 15px;
}
.personalization-close {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  color: #98a2b3;
  background: transparent;
  cursor: pointer;
}
.personalization-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -4px;
}
.personalization-clear {
  padding: 0;
  border: 0;
  color: #1677ff;
  background: transparent;
  font-size: 12px;
  cursor: pointer;
}
.personalization-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #1677ff;
  font-size: 12px;
}
.personalization-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.personalization-label {
  font-size: 12px;
  font-weight: 700;
  color: #344054;
}
.personalization-label i {
  color: #98a2b3;
  font-size: 12px;
}
.personalization-field ::v-deep .el-select {
  width: 100%;
}
.personalization-select ::v-deep .el-input__inner {
  height: 34px;
  border-color: #d9e4f5;
  border-radius: 6px;
  background: #fff;
}
.personalization-select ::v-deep .el-tag {
  height: 22px;
  line-height: 20px;
  margin: 2px 0 2px 6px;
  color: #344054;
  border: 0;
  background: #eef0f4;
}
.personalization-count-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #98a2b3;
  font-size: 11px;
}
.personalization-count-row button {
  padding: 0;
  border: 0;
  color: #1677ff;
  background: transparent;
  font-size: 11px;
  cursor: pointer;
}
.personalization-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 6px;
}
.personalization-footer .el-button {
  min-width: 78px;
}
.personalization-footer .el-button--primary {
  background: #2563eb;
  border-color: #2563eb;
}
::v-deep .personalization-popper {
  padding: 16px 16px 14px;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);
}
::v-deep .selected-personalization-dialog {
  border-radius: 10px;
}
::v-deep .selected-personalization-dialog .el-dialog__header {
  padding: 18px 20px 8px;
}
::v-deep .selected-personalization-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 700;
  color: #101828;
}
::v-deep .selected-personalization-dialog .el-dialog__body {
  padding: 10px 20px 4px;
}
::v-deep .selected-personalization-dialog .el-dialog__footer {
  padding: 12px 20px 18px;
}
.selected-personalization-list {
  max-height: 320px;
  overflow-y: auto;
}
.selected-personalization-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 6px 8px 6px 12px;
  margin-bottom: 8px;
  border: 1px solid #dfe8f6;
  border-radius: 8px;
  background: #fbfdff;
}
.selected-personalization-item span {
  overflow: hidden;
  color: #344054;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selected-personalization-item button {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  color: #667085;
  background: transparent;
  cursor: pointer;
}
.selected-personalization-item button:hover {
  color: #fff;
  background: #ef4444;
}
.selected-personalization-empty {
  padding: 28px 0;
  color: #98a2b3;
  text-align: center;
  background: #fbfdff;
  border: 1px dashed #dfe8f6;
  border-radius: 8px;
}
.chat-main-shell.is-welcome {
  width: min(calc(100vw - 360px), 1180px);
  min-width: 980px;
  min-height: 760px;
  margin-top: 30px;
  margin-bottom: 0;
}
.chat-main-shell.is-welcome .clomn_center {
  margin-top: 0;
  justify-content: flex-start;
}
.academic-welcome-title {
  margin: 0 auto 38px;
  text-align: center;
}
.academic-welcome-title h1 {
  margin: 0;
  color: #111827;
  font-size: 44px;
  font-weight: 800;
  line-height: 1.16;
  letter-spacing: 0;
}
.academic-welcome-title h1 span {
  color: #2563eb;
}
.academic-welcome-title h1 i {
  margin-left: 8px;
  color: #2563eb;
  font-size: 30px;
  transform: rotate(-14deg);
}
.academic-welcome-title p {
  margin: 12px 0 0;
  color: #1f2f4a;
  font-size: 18px;
  line-height: 1.5;
}
.chat-main-shell.is-welcome .user_input {
  padding: 28px 30px 30px;
  border-radius: 14px !important;
  background: #fff !important;
  box-shadow: 0 28px 70px rgba(28, 77, 145, 0.12);
}
.chat-main-shell.is-welcome .academic-search-field {
  height: 154px;
  padding: 24px 24px 0 60px;
  border: 1px solid #cfe0f8;
  border-radius: 14px;
  box-shadow: inset 0 0 0 1px rgba(48, 108, 207, 0.03), 0 12px 30px rgba(37, 99, 235, 0.06);
}
.academic-search-icon {
  position: absolute;
  top: 30px;
  left: 24px;
  color: #203b6a;
  font-size: 28px;
}
.chat-main-shell.is-welcome .academic-search-field :deep(.el-textarea__inner) {
  max-width: none;
  padding: 0;
  color: #111827;
  background: transparent !important;
  font-size: 17px !important;
  line-height: 28px;
}
.chat-main-shell.is-welcome .academic-search-field :deep(.el-textarea__inner::placeholder) {
  color: #8b95a8;
}
.chat-main-shell.is-welcome .user_input > div:nth-child(2) {
  margin: -68px 18px 0 20px !important;
  align-items: center;
  position: relative;
  z-index: 2;
}
.chat-main-shell.is-welcome .model-select_model {
  height: 44px;
  padding: 0 18px;
  gap: 8px;
  border: 1px solid #d6e5fb;
  border-radius: 22px;
  background: #fff;
  color: #1461d8;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.05);
}
.chat-main-shell.is-welcome .model-active_model {
  padding: 0;
  background: transparent;
  box-shadow: none;
}
.chat-main-shell.is-welcome .model-select_model_flex:first-of-type {
  margin-right: 0;
}
.academic-mode-arrow {
  margin-left: 4px;
}
.chat-main-shell.is-welcome .customization-button.academic-filter-button {
  width: auto;
  height: 44px;
  min-width: 0;
  padding: 0 18px !important;
  gap: 8px;
  border-radius: 22px;
  border-color: #d6e5fb;
  background: #fff;
  color: #1461d8;
  font-size: 15px;
  font-style: normal;
}
.chat-main-shell.is-welcome .customization-button.academic-filter-button em {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2563eb;
}
.academic-search-submit {
  height: 44px;
  min-width: 128px;
  padding: 0 24px;
  border: 0;
  border-radius: 24px;
  color: #fff;
  background: #2563eb;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.32);
  font-size: 16px;
  font-weight: 700;
}
.academic-search-submit:hover,
.academic-search-submit:focus {
  color: #fff;
  background: #1d55d8;
}
.academic-search-submit.is-disabled,
.academic-search-submit.is-disabled:hover {
  color: #fff;
  background: #a9c4f8;
  box-shadow: none;
}
.chat-main-shell.is-welcome .academic-assist-panel {
  margin: 40px 0 0;
  padding: 0;
  border-top: 0;
}
.chat-main-shell.is-welcome .assist-type-row {
  gap: 22px;
  margin-bottom: 30px;
}
.chat-main-shell.is-welcome .assist-label {
  font-size: 15px;
  color: #111827;
}
.chat-main-shell.is-welcome .assist-items {
  gap: 14px;
}
.chat-main-shell.is-welcome .assist-chip {
  height: 40px;
  line-height: 38px;
  padding: 0 18px;
  border-radius: 20px;
  background: #fbfdff;
  color: #1261df;
  border-color: #d8e6fb;
  box-shadow: none;
  font-size: 15px;
}
.chat-main-shell.is-welcome .question-guide-trigger {
  height: 40px;
  padding: 0 2px;
  border: 0;
  border-radius: 0;
  color: #1261df;
  background: transparent;
  font-size: 15px;
}
.chat-main-shell.is-welcome .question-guide-trigger:hover {
  text-decoration: underline;
  color: #1261df;
  background: transparent;
}
.chat-main-shell.is-welcome .assist-content-grid {
  grid-template-columns: minmax(0, 1fr) minmax(360px, 1fr);
  gap: 32px;
  padding-top: 28px;
  border-top: 1px solid #e2ebf7;
}
.chat-main-shell.is-welcome .assist-list-section.recent-section {
  padding-left: 32px;
  border-left: 1px solid #e2ebf7;
}
.chat-main-shell.is-welcome .assist-section-header {
  height: 28px;
  margin-bottom: 18px;
  font-size: 18px;
}
.chat-main-shell.is-welcome .assist-list-item {
  height: 52px;
  margin-bottom: 10px;
  border-color: #dfe8f6;
  border-radius: 10px;
  box-shadow: none;
}
.chat-main-shell.is-welcome .recent-section .assist-list-item {
  grid-template-columns: 24px minmax(0, 1fr) auto;
}
.assist-list-item em {
  color: #68758d;
  font-size: 14px;
  font-style: normal;
  white-space: nowrap;
}
@media (max-width: 1280px) {
  .chat-main-shell.is-welcome {
    width: calc(100vw - 250px);
    min-width: 0;
  }
}
::v-deep .user_ask {
  padding: 8px 15px;
  background-color: var(--label-bg);
  color: var(--txt-color);
  overflow-wrap: break-word;
  max-width: 500px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
/* 学术搜索场景下用户提问气泡改用浅蓝底(--label-bg-blue,亮/暗模式均已有对应色值),
   和通用灰底的标签/免责声明等次要提示区分开,不再依赖前缀文字标识来源。 */
::v-deep .chat-main-shell--academic .user_ask {
  background-color: var(--label-bg-blue);
}
::v-deep .process {
  font-size: 14px;
  background-color: var(--bg-back);
  color: var(--label-color);
  margin: 5px;
}
::v-deep .disclaimer {
  font-size: 12px;
  color: var(--txt-color3);
  margin: 10px 0;
}
::v-deep .condition {
  background-color: var(--label-bg);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 12px 10px;
}

/* ---- RAG 检索过程「思考链」：可折叠、带层次 ---- */
::v-deep .rag-trace {
  margin: 8px 10px 14px;
  border: 1px solid var(--label-border);
  border-radius: 10px;
  background-color: var(--bg-back);
  overflow: hidden;
  font-size: 13px;
}
::v-deep .rag-trace > summary,
::v-deep .rag-trace-step > summary {
  list-style: none;
  cursor: pointer;
  user-select: none;
}
::v-deep .rag-trace > summary::-webkit-details-marker,
::v-deep .rag-trace-step > summary::-webkit-details-marker {
  display: none;
}
::v-deep .rag-trace-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  color: var(--label-color2);
  font-weight: 600;
}
::v-deep .rag-trace-summary i.el-icon-cpu {
  color: var(--blue);
}
::v-deep .rag-trace-progress {
  margin-left: auto;
  font-size: 12px;
  font-weight: 500;
  color: var(--txt-color3);
  font-variant-numeric: tabular-nums;
}
::v-deep .rag-trace-body {
  margin: 0 12px 8px 21px;
  padding-left: 12px;
  border-left: 1px solid var(--label-border);
}
::v-deep .rag-trace-step {
  padding: 1px 0;
}
::v-deep .rag-trace-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 6px;
  border-radius: 6px;
  color: var(--label-color);
  transition: background-color 0.15s ease;
}
::v-deep .rag-trace-step > summary.rag-trace-head:hover {
  background-color: var(--label-bg);
}
::v-deep .rag-trace-title {
  flex: 1;
  min-width: 0;
  font-weight: 500;
}
::v-deep .rag-trace-caret {
  color: var(--txt-color3);
  font-size: 12px;
  transition: transform 0.18s ease;
}
::v-deep .rag-trace-step[open] > summary .rag-trace-caret {
  transform: rotate(90deg);
}
::v-deep .rag-trace-detail {
  margin: 2px 0 6px 18px;
  padding-left: 12px;
  border-left: 1px dashed var(--label-border);
}
::v-deep .rag-trace-line {
  padding: 2px 0;
  color: var(--label-color2);
  line-height: 1.7;
  font-family: "SFMono-Regular", "JetBrains Mono", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12.5px;
  word-break: break-word;
}
::v-deep .rag-trace-children {
  margin-top: 4px;
}
::v-deep .rag-trace-subitem {
  padding: 3px 0;
}
::v-deep .rag-trace-subhead {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--label-color);
}
::v-deep .rag-trace-subtitle {
  font-weight: 500;
  font-size: 12.5px;
}
::v-deep .rag-trace-dot {
  flex: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--txt-color3);
}
::v-deep .rag-trace-dot.done {
  background-color: var(--blue);
}
::v-deep .rag-trace-dot.failed {
  background-color: #f56c6c;
}
::v-deep .rag-trace-dot.running {
  background-color: var(--blue);
  box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.55);
  animation: ragTracePulse 1.2s ease-out infinite;
}
@keyframes ragTracePulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.5);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

.slow_hide {
  transition: all 0.3s ease;
  transform: translateX(100%);
  opacity: 0;
}
.slow_show {
  transition: all 0.3s ease;
  transform: translateX(0);
  opacity: 1;
}
::v-deep .refer_art {
  cursor: pointer;
  margin: 0 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%; /* 圆形关键 */
  background-color: var(--a-color);
  color: #ffffff; /* 白色文字 */
  font-size: 11px;
  font-weight: 500;
  display: inline-flex; /* 琛屽唴鍧楃骇锛屽彲涓庡叾浠栧厓绱犲悓琛?*/
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  top: -2px;
}

.clomn_center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -100px;
}
.clomn_between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.search_btn {
  color: #409eff;
  border-color: #98ccff;
}
.search_btn:hover {
  color: #2d8cf0;
  border-color: #409eff;
}
</style>
